<ng-container *transloco="let t">
  @if (categoryList.length < 1 && !disableEditing) {
    <p>
      <ngb-alert [dismissible]="false" class="warning-info p-3">
        {{ t("race.details.settings.category.warning.1") }}
        <strong><a (click)="navigateToOrganiserPage()">
          {{ race?.organiser?.name }}</a></strong>{{ t("race.details.settings.category.warning.2") }}
      </ngb-alert>
    </p>
  }
  <form [formGroup]="inputForm">
    <app-admin-card-with-title
      [cardTitle]="t('race.settings.basic.settings')" [removeTopMargin]="true">
      <div class="row">
        <div class="col-12 col-xl-4 pb-3">
          <!-- Application Procedure Dropdown -->
          <app-select formControlName="applicationProcedure"
                      [items]="applicationProcedureTypes" valueKey="id" labelKey="id"
                      labelKeyPrefix="race.settings.applicationProcedure." label="race.settings.applicationProcedure"/>
        </div>
        <div class="col-12 col-xl-4 pb-3">
          <!-- Category -->
          <app-select formControlName="category" [items]="categoryList"
                      valueKey="id" [labelKey]="'name'" label="app.common.category"/>
        </div>
        <div class="col-12 col-xl-4 pb-3">
          <!-- Type of Application Dropdown -->
          <app-select formControlName="typeOfApplication"
                      [items]="typeOfApplicationTypes" valueKey="id" labelKey="id"
                      labelKeyPrefix="race.settings.typeOfApplication." label="race.settings.typeOfApplication"/>
        </div>
        <div class="col-12 col-xl-4 pb-3">
          <!-- Measurement Precision Type Dropdown 2 -->
          <app-select formControlName="teamType" [items]="teamTypes"
                      valueKey="id" labelKey="id" labelKeyPrefix="race.settings.team.type."
                      label="race.settings.team.type"/>
        </div>
        <div class="col-12 col-xl-4 pb-3">
          <!-- Selection of Team Members Type Dropdown -->
          <app-select formControlName="selectionOfTeamMembersType"
                      valueKey="id" labelKey="id" [items]="selectionOfTeamMembersTypes"
                      labelKeyPrefix="race.settings.selectionOfTeamMembersType."
                      label="race.settings.selectionOfTeamMembersType"/>
        </div>
        <div class="col-12 col-xl-4">
          <div class="row">
            <div class="col-12 col-xl-5 pb-3">
              <!-- Team Name Type Dropdown -->
              <app-select formControlName="teamNameRequired"
                          [items]="[false, true]" [labels]="['app.common.not.required', 'app.common.required']"
                          label="race.settings.team.name.type"/>
            </div>
            <div class="col-12 col-xl-7 pb-3">
              <!-- Gender of Team Members Type Dropdown -->
              <app-select formControlName="genderRequired"
                          [items]="[false, true]" [labels]="['app.common.not.required', 'app.common.required']"
                          label="race.settings.gender.type"/>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-12 col-xl-6">
              <div class="row">
                <div class="col-12 col-xl-5 d-flex align-items-center">
                  <div class="form-check form-switch justify-content-between align-items-center pb-2">
                    <!-- Enable group registration payment -->
                    <input ngDefaultControl class="form-check-input" type="checkbox"
                           formControlName="enableGroupRegistrationPayment">
                    <label class="form-check-label">
                      {{ t("race.settings.group.registration.payment") }}
                    </label>
                  </div>
                  <ng-template #errorMessage>
                    @for (errorMessage of inputForm.controls['enableGroupRegistrationPayment'].errors | errorMessages:'enableGroupRegistrationPayment';track errorMessage) {
                    {{errorMessage}}
                    }
                  </ng-template>
                  @if (inputForm.controls['enableGroupRegistrationPayment'].errors) {
                  <div class="info-box align-items-center">
                    <i class="bi bi-info-circle info-icon error" [ngbTooltip]="errorMessage" placement="top"></i>
                  </div>
                  }
                </div>
                <div class="col-12 col-xl-7 pb-3">
                  <app-input type="number" formControlName="maxGroupRegisteredParticipants"
                             label="race.settings.max.number.of.group.registered.participants" [min]="1"/>
                </div>
              </div>
            </div>
          @if (inputForm.controls['blockStart'].enabled) {
            <div class="col-12 col-xl-6">
              <div class="row">
                <div class="col-12 col-xl-4 d-flex align-items-center">
                  <div class="form-check form-switch justify-content-between align-items-center pb-2">
                    <input ngDefaultControl class="form-check-input" type="checkbox"
                           formControlName="blockStart">
                    <label class="form-check-label">
                      {{ t("race.settings.blockStart") }}
                    </label>
                  </div>
                </div>
                <div class="col-12 col-xl-8 pb-3">
                  <app-input type="number" formControlName="maxParticipantsInStartBlock"
                             label="race.settings.maxParticipantsInStartBlock" [min]="1"/>
                </div>
              </div>
            </div>
            }
          </div>
        </div>

      </div>
    </app-admin-card-with-title>
    <app-admin-card-with-title
      [cardTitle]="t('race.settings.timing.settings')">

      <div class="row">
        <div class="col-12 col-xl-6 pb-3">
          <!-- Measurement Precision Type Dropdown -->
          <app-select formControlName="measurementType"
                      [items]="measurementTypes" valueKey="id" labelKey="id"
                      labelKeyPrefix="race.settings.measurementType." label="race.settings.measurementType"/>
        </div>
        <div class="col-12 col-xl-6">
          <div class="row">
            <div class="col-12 col-xl-6 pb-3">
              <!-- Measurement Precision Type Dropdown 2 -->
              <app-select formControlName="measurementPrecisionType" valueKey="id"
                          labelKey="id" [items]="measurementPrecisionTypes"
                          labelKeyPrefix="race.settings.measurementPrecisionType."
                          label="race.settings.measurementPrecisionType"/>
            </div>
            <div class="col-12 col-xl-6 pb-3">
              <!-- Start by Gender or Age Category Dropdown -->
              <app-select formControlName="startByType" [items]="startByTypeTypes"
                          valueKey="id" labelKey="id" labelKeyPrefix="race.settings.startByType."
                          label="race.settings.startByType"/>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-xl-6 pb-3">
          <app-select formControlName="timingSystem" [items]="timingSystems"
                      valueKey="id" labelKey="id" labelKeyPrefix="race.settings.timing.system."
                      label="race.settings.timing.system"/>
        </div>
        <div class="col-12 col-xl-6 pb-3">
          <app-select formControlName="timingEquipment"
                      [items]="timingEquipments" valueKey="id" labelKey="id"
                      labelKeyPrefix="race.settings.select.equipment."
                      label="race.settings.select.equipment"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-6">
          <!-- resultProcessingTypes -->
          <div class="d-flex align-items-top mb-3">
            <div class="flex-grow-1">
              <app-select formControlName="resultProcessingType"
                          [items]="resultProcessingTypes"
                          [labelKeyPrefix]="'race.settings.resultProcessingType.'"
                          label="race.settings.resultProcessingType"/>
            </div>
            @if (race?.sport === SportType.BACKYARD_ULTRA) {
            <div class="info-box">
             <i class="bi bi-info-circle info-icon"
                 ngbTooltip="{{ t('race.settings.roundRace.backyard.info') }}" placement="top"></i>
            </div>
            }
          </div>
        </div>
        @if (inputForm.controls['resultProcessingType'].value === ResultProcessingType.ROUND_RACE || inputForm.controls['resultProcessingType'].value === ResultProcessingType.TIME_LIMITED) {
        <div class="col-12 col-xl-3">
          <!-- Minimalno trajanje kruga-->
          <div class="d-flex align-items-top mb-3">
            <div class="flex-grow-1">
              <app-input type="number" formControlName="minimumLapDuration"
                         label="race.settings.minimumLapDuration" [min]="1"/>
            </div>
          </div>
        </div>
        }
        @if (inputForm.controls['resultProcessingType'].value === ResultProcessingType.TIME_LIMITED) {
        <div class="col-12 col-xl-3">
          <!-- duljina kruga-->
          <div class="d-flex align-items-top mb-3">
            <div class="flex-grow-1">
              <app-input type="number" formControlName="lapLength"
                         label="race.settings.lapLength" [min]="0"/>
            </div>
          </div>
        </div>
        }
      </div>

    </app-admin-card-with-title>
    <app-admin-card-with-title
      [cardTitle]="t('race.settings.ranking.settings')">
      <div class="row">
        <!-- Use group ranking -->
        <div class="col-12 d-flex mb-3">
          <div class="form-check form-switch justify-content-between align-items-center">
            <!-- Enable group ranking -->
            <input ngDefaultControl class="form-check-input" type="checkbox" formControlName="useGroupRanking">
            <label class="form-check-label">
              {{ t("race.settings.use.group.ranking") }}
            </label>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <!-- Broj natjecatelja iz ekipe za rangiranje-->
          <div class="d-flex align-items-top mb-3">
            <div class="flex-grow-1">
              <app-input type="number" formControlName="teamParticipantsForRanking"
                         label="race.settings.teamParticipantsForRanking"/>
            </div>
            <div class="info-box">
              <i class="bi bi-info-circle info-icon"
                 ngbTooltip="{{ t('race.settings.teamParticipantsForRanking.description') }}" placement="top"></i>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-6">
          <!-- Ekipno rangiranje razdvajanje po spolu -->
          <div class="d-flex align-items-top mb-3">
            <div class="flex-grow-1">
              <app-select formControlName="teamRankingGenderSeparation"
                          valueKey="id" labelKey="id" [items]="genderSeparationTypes"
                          labelKeyPrefix="race.settings.ranking.gender.separation."
                          label="race.settings.teamRankingGenderSeparation"/>
            </div>
            <div class="info-box">
              <i class="bi bi-info-circle info-icon"
                 ngbTooltip="{{ t('race.settings.teamRankingGenderSeparation.description') }}" placement="top"></i>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-3">
          <!--          "Grupe za rangiranje (odvojeni točka-zarezom)"-->
          <div class="d-flex align-items-top mb-3">
            <div class="flex-grow-1">
              <app-tags-input [inputLabel]="t('race.settings.rankingGroups')"
                              [tags]="inputForm.controls['rankingGroups'].value"
                              [disabled]="disableEditing || inputForm.controls['rankingGroups'].disabled"
                              [isRequired]="inputForm.controls['rankingGroups'].errors?.['required']"
                              [showErrorMessage]="inputForm.controls['rankingGroups'].touched"
                              [errors]="inputForm.controls['rankingGroups'].errors"
                              (onTagRemoved)="removeTagAtIndex($event)" (tagsChanged)="rankingGroupsChanged($event)"/>
            </div>
            <div class="info-box">
              <i class="bi bi-info-circle info-icon" ngbTooltip="{{ t('race.settings.rankingGroups.description') }}"
                 placement="top"></i>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-3">
          <!-- Prikaz prvih N rangiranih natjecatelja -->
          <div class="d-flex align-items-top mb-3">
            <div class="flex-grow-1">
              <app-input type="number" formControlName="topRanked" label="race.settings.topRanked"
                         [min]="0"/>
            </div>
            <div class="info-box">
              <i class="bi bi-info-circle info-icon" ngbTooltip="{{ t('race.settings.topRanked.description') }}"
                 placement="left"></i>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-3">
          <!--          Grupno rangiranje razdvajanje po spolu-->
          <div class="d-flex align-items-top mb-3">
            <div class="flex-grow-1">
              <app-select formControlName="groupRankingSeparation"
                          valueKey="id" labelKey="id" [items]="genderSeparationTypes"
                          labelKeyPrefix="race.settings.ranking.gender.separation."
                          label="race.settings.groupRankingSeparation"/>
            </div>
            <div class="info-box">
              <i class="bi bi-info-circle info-icon"
                 ngbTooltip="{{ t('race.settings.groupRankingSeparation.description') }}" placement="top"></i>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-3">
          <!-- Ekipno rangiranje razdvajanje po ekipi/timu-->
          <div class="d-flex align-items-top mb-3">
            <div class="flex-grow-1">
              <app-select formControlName="teamRankingTeamSeparation"
                          [items]="teamRankingTeamSeparationTypes" valueKey="id" labelKey="id"
                          labelKeyPrefix="race.settings.teamRankingTeamSeparation."
                          label="race.settings.teamRankingTeamSeparation"/>
            </div>
            <div class="info-box">
              <i class="bi bi-info-circle info-icon"
                 ngbTooltip="{{ t('race.settings.teamRankingTeamSeparation.description') }}" placement="top"></i>
            </div>
          </div>
        </div>
      </div>
    </app-admin-card-with-title>
    <app-admin-card-with-title
      [cardTitle]="t('race.settings.results.display.settings')">
      <div class="row">
        <div class="col-12 col-xl-3">
          <app-input type="number" formControlName="participantsFromRankingGroup"
                     label="race.settings.participantsFromRankingGroup" [min]="0"/>
        </div>
        <div class="col-12 col-xl-3">
          <!-- Results per page-->
          <div class="d-flex align-items-top mb-3">
            <div class="flex-grow-1">
              <app-input type="number" formControlName="resultsPerPage"
                         label="race.settings.resultsPerPage" [min]="0"/>
            </div>
            <div class="info-box">
              <i class="bi bi-info-circle info-icon" ngbTooltip="{{ t('race.settings.resultsPerPage.description') }}"
                 placement="top"></i>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-3 pb-3">
          <!-- Kontrolne točke-->
          <app-input formControlName="controlPoints" label="race.settings.controlPoints"/>
        </div>
        <div class="col-12 col-xl-3 pb-3">
          <!-- Kaznene minute-->
          <app-select formControlName="penaltyMinutes"
                      [items]="penaltyMinutesTypes" valueKey="id" labelKey="id"
                      labelKeyPrefix="race.settings.visibilityTypes."
                      label="race.settings.penaltyMinutes"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-xl-3 pb-3">
          <!-- prikaz rezultata-->
          <app-select formControlName="resultDisplayType"
                      [items]="resultDisplayTypes" valueKey="id" labelKey="id"
                      labelKeyPrefix="race.settings.resultDisplayType."
                      label="race.settings.resultDisplayType"/>
        </div>
        <div class="col-12 col-xl-3 pb-3">
          <!-- Rotirajući rezultati prikazani sekundi-->
          <app-input type="number" formControlName="rotatingResultsSeconds"
                     label="race.settings.rotatingResultsSeconds"/>
        </div>
      </div>
    </app-admin-card-with-title>

    <app-admin-card-with-title
      [cardTitle]="t('race.settings.control.points.settings')">
      <div class="row">
        <div class="col-xl-6 col-12">
          <div class="col-12">
            <div class="d-flex align-items-top mb-3">
              <div class="pe-4">
                <app-checkbox formControlName="usingUploadRoute" [label]="t('race.settings.usingUploadRoute')"/>
              </div>
              <div class="ps-2">
                <i class="bi bi-info-circle info-icon"
                   ngbTooltip="{{ t('race.settings.usingUploadRoute.description') }}" placement="top"></i>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="d-flex align-items-top mb-3 ">
              <div class="pe-4">
                <app-checkbox formControlName="displayControlPoints" [label]="t('race.settings.displayControlPoints')"/>
              </div>
              <div class="ps-2">
                <i class="bi bi-info-circle info-icon"
                   ngbTooltip="{{ t('race.settings.displayControlPoints.description') }}" placement="top"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-12">
          <div class="col-12">
            <div class="d-flex align-items-top mb-3">
              <div class="pe-4">
                <app-checkbox formControlName="showRouteProfile" [label]="t('race.settings.showRouteProfile')"/>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="d-flex align-items-top mb-3">
              <div class="pe-4">
                <app-checkbox formControlName="enableGPXDownload" [label]="t('race.settings.enableGPXDownload')"/>
              </div>
            </div>
          </div>
          <!--          <div class="col-12">
                      <div class="d-flex align-items-top mb-3">
                        <div class="pe-4">
                          <app-checkbox formControlName="usingDistanceMarkersOnRoute"
                                        [label]="t('race.settings.usingDistanceMarkersOnRoute')"/>
                        </div>
                      </div>
                    </div>
                     <div class="col-12">
                      <app-multiselect-dropdown [options]="distanceMarkers" [formControlName]="'distanceMarkersOnRoute'"
                                                [dropdownLabel]="t('race.settings.distanceMarkersOnRoute')"/>
                    </div> -->
        </div>
      </div>
    </app-admin-card-with-title>
    <app-admin-card-with-title
      [cardTitle]="'URL'">
      <div class="row">
        <div class="col-12 mb-4">
          <!-- URL za vanjsku vezu za registraciju-->
          <app-input formControlName="registrationExternalUrl"
                     label="race.settings.registrationExternalUrl"/>
        </div>
      </div>
    </app-admin-card-with-title>
    <app-action-buttons-row (onSave)="onSave()" [disableEditing]="disableEditing"/>
  </form>
</ng-container>
